import { FileUploader } from '@toy/uploader';
import http from '@/core/http';

const fileUploader = new FileUploader({
  http: http as any,
  errorCapture: true,
  threshold: 1024 * 1024 * 20,
});

export default function useFileUploader() {
  return {
    fileUploader,
  };
}
